import { useContext } from 'react'
import { LeadRefetchContext } from './leadRefetch.context'
import type { LeadRefetchContextType } from './leadRefetch.types'

export const useLeadRefetch = (): LeadRefetchContextType => {
  const context = useContext(LeadRefetchContext)
  if (!context) {
    throw new Error('useLeadRefetch must be used within a LeadRefetchProvider')
  }
  return context
}

export const useOptionalLeadRefetch = (): LeadRefetchContextType | undefined =>
  useContext(LeadRefetchContext)
